import ReactGA from "react-ga4";

export function useGoogleAnalytics() {
  const gaTrackEvent = (event: string, params?: object) => {
    if (!ReactGA.isInitialized) return;
    ReactGA.event(event, params);
  };

  return { gaTrackEvent };
}
